import React, {PureComponent} from 'react';
import ChatSmileItem from 'app/components/chat/chat_smile_item';
import SmartLoader from 'app/components/reusable/SmartLoader';

export default class ChatSmileItems extends PureComponent {
    get classNames() {
        const classNames = [];
        const {withBorder, smiles} = this.props;

        if (withBorder && smiles.length > 0) {
            classNames.push('recent');
        }
        return classNames.join(' ');
    }

    render() {
        const {smiles, insertSmile, isLoading, titleList} = this.props;

        return <>
            <span className="chat__smile-list-title">{titleList}</span>
            {isLoading
                ? <SmartLoader/>
                : <div className={`chat__smile-item-list all-list-smileys ${this.classNames}`}>
                    {smiles.map(smile => <ChatSmileItem
                        key={smile}
                        smile={smile}
                        insertSmile={insertSmile}
                    />)}
                </div>}
        </>;
    }
}
